module.exports = __webpack_public_path__ + "img/open_cmd_windows.6eb232dc.png";